import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Paginator } from './../../../models/paginator.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-rounded-pagination',
  imports: [CommonModule],
  templateUrl: './rounded-pagination.component.html',
  styleUrls: ['./rounded-pagination.component.scss']
})
export class RoundedPaginationComponent {
  @Input() paginator: Paginator;
  pageNumbers: number[]=[];
  @Output("paginatorFind") paginatorFind: EventEmitter<any> = new EventEmitter();
  selectedPage=1;

  constructor(){}
  
  ngOnInit(): void {
  }

  ngOnChanges(): void {
    this.calculatePageNumbers();
  }

  calculateMaxPages() {
    return Math.ceil(this.paginator.count / this.paginator.size);
  }

  nextPage() {
    if (this.paginator.page<this.calculateMaxPages()) {
      this.paginator.page++;
      this.selectedPage=this.paginator.page;
      this.paginatorFind.emit();
    }
  }

  previousPage() {
    if (this.paginator.page>=1) {
      this.paginator.page--;
      this.selectedPage=this.paginator.page;
      this.paginatorFind.emit();
    }
  }

  selectPage(page:number) {
    this.selectedPage=page;
    this.paginator.page=page;
    this.paginatorFind.emit();
  }

  calculatePageNumbers(){
    this.pageNumbers=[];
    for (let i = 0; i < Math.ceil(this.paginator.count / this.paginator.size); i++) {
      this.pageNumbers.push(i+1);
    }
  }
}
